import { render, staticRenderFns } from "./surveysQuestionsAnswers.vue?vue&type=template&id=2dbdd58a&"
import script from "./surveysQuestionsAnswers.vue?vue&type=script&lang=js&"
export * from "./surveysQuestionsAnswers.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports